import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";
import { IDashboardState } from "../state/dashboard.state";
import { IInvoice, IInvoices } from "@edp-models/invoices.model";
import { StatusRequest } from "@edp-enums/edp-status-request.enum";
import moment from "moment";

const dashboardSelector = (state: IAppState) => state.dashboard;

export const getInvoices = createSelector(dashboardSelector, (state: IDashboardState) => state.invoices.data);

export const getDebtInvoices = createSelector(getInvoices, (state: IInvoices) => {
    return state.invoices === null
        ? null
        : state.invoices.filter((invoice: IInvoice) => {
              return invoice.status === "NP";
          });
});

export const getInvoicesAPIError = createSelector(dashboardSelector, (state: IDashboardState) => state.invoices.lastAPIError);

export const getBalance = createSelector(dashboardSelector, (state: IDashboardState) => state.balance.data);

export const getBalanceAPIError = createSelector(dashboardSelector, (state: IDashboardState) => state.balance.lastAPIError);

export const getActiveMetersElectricity = createSelector(dashboardSelector, (state: IDashboardState) => state.activeMetersElectricity);

export const getActiveMetersGas = createSelector(dashboardSelector, (state: IDashboardState) => state.activeMetersGas);

export const getSimulation = createSelector(dashboardSelector, (state: IDashboardState) => state.simulation);

export const getUploadReading = createSelector(dashboardSelector, (state: IDashboardState) => state.uploadReading);

export const getContractRequests = createSelector(dashboardSelector, (state: IDashboardState) => state.contractRequest.data);

export const getUnexpiredContractRequests = createSelector(dashboardSelector, (state: IDashboardState) => {
    if (state.contractRequest.data === null) {
        return state.contractRequest.data;
    }

    if (!state.contractRequest.data.filter) {
        return [];
    }

    return state.contractRequest.data.filter(req => {
        if (req.Status !== StatusRequest.RESOLVED) {
            return true;
        }

        // his status is resolved and his creation date is less then 30 days from now
        return (
            moment(req.CreationDate) >=
            moment()
                .startOf("day")
                .subtract(30, "days")
        );
    });
});

export const getContractRequestsAPIError = createSelector(
    dashboardSelector,
    (state: IDashboardState) => state.contractRequest.lastAPIError
);

export const getFunciona = createSelector(dashboardSelector, (state: IDashboardState) => state.funciona.data);

export const getFuncionaAPIError = createSelector(dashboardSelector, (state: IDashboardState) => state.funciona.lastAPIError);

export const getCampaigns = createSelector(dashboardSelector, (state: IDashboardState) => state.campaigns.data);

export const getCampaignsAPIError = createSelector(dashboardSelector, (state: IDashboardState) => state.campaigns.lastAPIError);

export const getRecaptcha = createSelector(dashboardSelector, (state: IDashboardState) => state.recaptcha);
export const getPartnershipCampaigns = createSelector(
    dashboardSelector,
    (state: IDashboardState) => state.campaigns.data.filter(
        campaign => campaign.linkFunctionality.name === "Parceria Comercial"
    )
);

export const getRecaptchaResponse = createSelector(dashboardSelector, (state: IDashboardState) => state.recaptchaResponse);

export const getBankList = createSelector(dashboardSelector, (state: IDashboardState) => state.bankList);

export const getMeterInstructions = createSelector(dashboardSelector, (state: IDashboardState) => state.meterInstructions.data);

export const getElectricMobilityWidget = createSelector(dashboardSelector, (state: IDashboardState) => state.electricMobility.data);

export const getElectricMobilityWidgetAPIError = createSelector(
    dashboardSelector,
    (state: IDashboardState) => state.electricMobility.lastAPIError
);

export const getShowNewLocalToastr = createSelector(
    dashboardSelector,
    (state: IDashboardState) => state.showNewLocalToastr
);
